import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5030/api';

export default function LeaveApprovalPage() {
  const { token } = useParams();
  const location = useLocation();
  const isApprove = location.pathname.includes('/approve/');

  useEffect(() => {
    const action = isApprove ? 'approve' : 'reject';
    window.location.href = `${API_URL}/hrm/leave/approval/${action}/${token}`;
  }, [token, isApprove]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif', background: '#ECEFF1' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <p style={{ marginTop: '20px', color: '#555' }}>Processing your request... Redirecting...</p>
      </div>
    </div>
  );
}
